export const environment = {
  production: true,
  apiURL: 'https://api.notionhabitheroes.com',
  // apiURL: 'http://localhost:8080'
  googleClientId: '185560953376-2o0jnee7gt4nl0lhm38gkfmbu8dkmk5u.apps.googleusercontent.com',
  socialLoginEnabled: true,
  // Notion OAuth (backlog #188). Plain (not URL-encoded) — buildNotionAuthUrl
  // in string-constants.ts encodes notionRedirectUri itself.
  notionClientId: '142d872b-594c-80d8-b8be-003715580b93',
//   notionClientId: '3c9d872b-594c-8121-b33b-0037906842a1',
  notionRedirectUri: 'https://notionhabitheroes.com/start',
  // Register-form minimum-fill-time bot gate (backlog #119). See environment.ts for why
  // dev/e2e run with this zeroed instead.
  registerMinFillTimeMs: 3000
};
